import {
  formatManageDateTimeIST,
  formatManageTimeIST,
  parseManageDateTimeUtc,
} from "@/lib/manageDateFormat";

const IST_TIMEZONE = "Asia/Kolkata";
const USE_BY_DAYS = 5;

function formatWeightLabel(weightKg) {
  const w = Number(weightKg);
  if (!Number.isFinite(w) || w <= 0) return "";
  return `${Math.round(w * 1000)} g`;
}

function formatIstDate(input) {
  const d = parseManageDateTimeUtc(input);
  if (!d) return "";
  return d.toLocaleDateString("en-GB", {
    timeZone: IST_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
}

function addCalendarDaysIst(input, days) {
  const d = parseManageDateTimeUtc(input);
  if (!d) return "";
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: IST_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(d);
  const y = Number(parts.find((p) => p.type === "year")?.value);
  const m = Number(parts.find((p) => p.type === "month")?.value);
  const day = Number(parts.find((p) => p.type === "day")?.value);
  if (!y || !m || !day) return "";
  const shifted = new Date(Date.UTC(y, m - 1, day + days, 12, 0, 0));
  return shifted.toLocaleDateString("en-GB", {
    timeZone: IST_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
}

function formatOrderIdLabel(orderNumber) {
  const n = orderNumber;
  if (n == null || n === "") return "";
  return `#${n}`;
}

function formatStampDeliveryAddress(info) {
  const blockHouse = String(info?.block_house_no || "").trim();
  const society = String(info?.customer_society || "").trim();
  const parts = [blockHouse, society].filter(Boolean);
  return parts.join(", ");
}

/** Build stamp values from a production task / order payload. */
export function buildFreshnessStampData(info) {
  const bakedTs = info?.production_baker_done_at;
  const frostedTs = info?.production_froster_done_at;

  const bakedOn = bakedTs ? formatIstDate(bakedTs) : "";
  const bakedAt = bakedTs ? formatManageTimeIST(bakedTs) : "";
  const useBy = bakedTs ? addCalendarDaysIst(bakedTs, USE_BY_DAYS) : "";
  const frostingTime = frostedTs ? formatManageDateTimeIST(frostedTs) : "";
  const weightLabel = formatWeightLabel(info?.weight_kg);

  return {
    orderNumber: info?.order_number,
    orderIdLabel: formatOrderIdLabel(info?.order_number),
    deliveryAddress: formatStampDeliveryAddress(info),
    bakedOn,
    bakedAt,
    useBy,
    frostingTime,
    weightLabel,
    hasBakerDone: Boolean(bakedTs),
    hasFrosterDone: Boolean(frostedTs),
    ready: true,
  };
}
